<template>
  <Head title="Login" />
  <div
    class="min-vh-100 d-flex align-items-center justify-content-center bg-light"
  >
    <DContainer class="py-5">
      <DRow class="justify-content-center">
        <DCol sm="10" md="8" lg="6" xl="4">
          <DCard>
            <h3 class="text-center mb-4">AstroAdmin Cloud</h3>

            <DXForm
              :form="loginForm"
              submit-text="Login"
              submit-loading-text="Logging in..."
              @submit="handleLogin"
            />
          </DCard>
        </DCol>
      </DRow>
    </DContainer>
  </div>
</template>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import {
  defineForm,
  DXForm,
  DContainer,
  DRow,
  DCol,
  DCard,
} from "@omnitend/dashboard-for-laravel";

const loginForm = defineForm([
  {
    key: "email",
    type: "email",
    label: "Email",
    placeholder: "Enter your email",
    required: true,
    default: "",
  },
  {
    key: "password",
    type: "password",
    label: "Password",
    placeholder: "Enter your password",
    required: true,
    default: "",
  },
  {
    key: "remember",
    type: "checkbox",
    label: "Remember me",
    default: false,
  },
] as const);

interface LoginResult {
  two_factor: boolean;
}

const handleLogin = async () => {
  try {
    const result = await loginForm.form.post<LoginResult>("/login");

    // Fortify answers a JSON login with {two_factor: bool} — NOT a redirect.
    // dfl's client sends `Accept: application/json`, so wantsJson() is true.
    // Neither dfl's form nor DXForm nor Inertia navigates on its own, so
    // without this the login succeeds, sets the cookie, and the page just sits
    // there looking broken.
    //
    // A hard navigation, not router.visit(): Laravel regenerates the session ID
    // on login, which rotates the CSRF token. An SPA visit would leave this
    // page's now-stale token in its <meta> tag and the next POST would 419.
    window.location.href = result?.two_factor
      ? "/two-factor-challenge"
      : "/sites";
  } catch {
    // dfl has already populated form.errors / form.message from the 422 and
    // DXForm renders them; swallow so the rejection isn't unhandled.
  }
};
</script>
